import { commonTypes } from '../common';

export const types = {
  SET_AFTER_SALE_PARENT_PRODUCTS_TO_SELECT: 'UINEEDS/SET_AFTER_SALE_PARENT_PRODUCTS_TO_SELECT',
};

export const initialState = {
  parentProductsToSelect: null,
  parentProductSelected: null,
  afterSaleParentProductsToSelect: null,
  afterSaleParentProductSelected: null,
};

const UINeedsParentProductsReducer = (state, action) => {
  switch (action.type) {
    case commonTypes.SET_PARENT_PRODUCTS_TO_SELECT: {
      const { parentProducts } = action.payload;

      if (parentProducts
        && Array.isArray(parentProducts)
        && parentProducts.length > 1
      ) {
        const newState = { ...state };
        newState.parentProductsToSelect = parentProducts;

        return {
          state: newState,
          stepsMustBeEvaluated: true,
        };
      }
      if (
        parentProducts
        && Array.isArray(parentProducts)
        && parentProducts.length === 1
      ) {
        const newState = {
          ...state,
          parentProductSelected: parentProducts[0],
        };

        return {
          state: newState,
          stepsMustBeEvaluated: false,
        };
      }

      return null;
    }
    case commonTypes.SET_PARENT_PRODUCT_SELECTED: {
      const { productSelected } = action.payload;

      if (productSelected) {
        const newState = { ...state };
        newState.parentProductSelected = productSelected;

        return {
          state: newState,
          stepsMustBeEvaluated: true,
        };
      }

      return null;
    }
    case types.SET_AFTER_SALE_PARENT_PRODUCTS_TO_SELECT: {
      const { parentProducts } = action.payload;

      if (parentProducts
        && Array.isArray(parentProducts)
        && parentProducts.length > 1
      ) {
        const newState = { ...state };
        newState.afterSaleParentProductsToSelect = parentProducts;

        return {
          state: newState,
          stepsMustBeEvaluated: true,
        };
      }

      return null;
    }
    case commonTypes.SET_AFTER_SALE_PARENT_PRODUCT: {
      const { afterSaleParentProduct } = action.payload;

      const newState = {
        ...state,
        afterSaleParentProductSelected: {
          productId: afterSaleParentProduct.id,
          phoneNumber: afterSaleParentProduct.label,
        },
      };

      return {
        state: newState,
        stepsMustBeEvaluated: true,
      };
    }
    default:
      return null;
  }
};

export const actions = {
  setAfterSaleParentProductsToSelect: parentProducts => ({
    type: types.SET_AFTER_SALE_PARENT_PRODUCTS_TO_SELECT,
    payload: {
      parentProducts,
    },
  }),
};

export default UINeedsParentProductsReducer;
